import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDownloadLaudo } from "../../../hooks/queries/agendamento/useDownloadLaudo/useDownloadLaudo";

export const useDownloadLaudoPage = () => {
  const { uuidAgendamento } = useParams();
  const { mutate, isPending, isError } = useDownloadLaudo();

  useEffect(() => {
    if (uuidAgendamento) mutate({ uuid: uuidAgendamento });
  }, [uuidAgendamento]);

  return { isPending, isError };
};
